import {
	Button,
	Col,
	Divider,
	Form,
	Input,
	Row,
	Select,
	Upload,
	notification,
	Typography,
	Checkbox,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { UploadOutlined } from "@ant-design/icons";
const { Text, Title } = Typography;

const statusOptions = [
	{
		value: "New",
		label: "New",
	},
	{
		value: "In Progress",
		label: "In Progress",
	},
	{
		value: "Closed",
		label: "Closed",
	},
];

const optionsType = [
	{
		value: "ETICKET",
		label: "ETICKET",
	},
	{
		value: "JAP",
		label: "JAP",
	},
];

const optionsCompany = [
	{
		value: "Castle",
		label: "Castle",
	},
	{
		value: "Logistics",
		label: "Logistics",
	},
	{
		value: "57Concrete",
		label: "57Concrete",
	},
	{
		value: "Fuels",
		label: "Fuels",
	},
];

/**
 ** Options header (columns)
 */
const columns = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		render: (value) => {
			return <Text strong>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Status",
		dataIndex: "status",
		key: "status",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const EditTask = ({ history, match }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [loadingButton, setLoadingButton] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [evidenceAdded, setEvidenceAdded] = useState(false);
	const [initialValues, setInitialValues] = useState({});
	const [defaultFileList, setDefaultFileList] = useState([]);
	const [evidenceRemoved, setEvidenceRemoved] = useState([]);
	const [historyStatus, setHistoryStatus] = useState([]);
	const [userList, setUserList] = useState([]);
	const [userLoading, setUserLoading] = useState(true);
	const [disabledApproved, setDisabledApproved] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getUsers();
		getTask();
	}, []);

	const getUsers = async () => {
		try {
			const url = api + "/user/list/task";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						label: `${item.role} - ${item.name.toUpperCase()}`,
						value: item._id,
					});
				});
				setUserList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setUserLoading(false);
		} catch (err) {
			setUserLoading(false);
			openNotification("error", "Error", "Error while trying to get users");
			console.error(err.message);
			return null;
		}
	};

	const getTask = async () => {
		try {
			setLoading(true);
			const url = api + `/task/get/${match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				const payload = data.payload;
				setInitialValues({
					number: payload.number,
					type: payload.type,
					description: payload.description,
					title: payload.title,
					status: payload.status,
					authorizedBy: payload.authorizedBy,
					company: payload.company,
					billId: payload.billId,
					paid: payload.paid || false,
					approved: payload.approved || false,
				});

				if (payload.approved || false) {
					setDisabledApproved(true);
				} else {
					setDisabledApproved(false);
				}

				let historyData = [];

				payload.statusHistory.map((item) => {
					historyData.push({
						date: new Intl.DateTimeFormat("en-US", {
							month: "numeric",
							year: "numeric",
							day: "numeric",
							hour: "2-digit",
							minute: "2-digit",
							second: "2-digit",
						}).format(new Date(item.createdAt)),
						user: item.user.name,
						status: item.status,
					});
				});

				setHistoryStatus(historyData);

				let images = [];
				payload.evidence.map((image) => {
					let name = image.split("/")[5];
					images.push({
						uid: name,
						name: name,
						url: image,
						status: "done",
					});
				});
				setDefaultFileList(images);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get task");
			console.error(err.message);
			return null;
		}
	};

	const updateTask = async (values) => {
		const task = {
			...values,
		};

		delete task.evidence;
		delete task.number;

		let evidences = [];
		evidenceRemoved.map((evidence) => {
			const index = defaultFileList.findIndex((file) => evidence === file.url);
			if (index !== -1) {
				delete defaultFileList[index];
			}
		});

		defaultFileList.map((file) => {
			evidences.push(file.url);
		});

		task.evidence = evidences;

		try {
			const url = api + `/task/update/${match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.patch(url, task);
			if (data.success) {
				if (evidenceAdded) {
					addEvidence(values, data.payload._id);
				} else {
					openNotification("success", "Success", data.message);

					setTimeout(() => {
						setLoadingButton(false);
						history.push("/task/dashboard");
					}, 2000);
				}
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification("error", "Error", "Error while trying to update task");
			console.error(err.message);
			return null;
		}
	};

	const addEvidence = async (values, id) => {
		const formData = new FormData();

		if (evidenceAdded && values.evidence && values.evidence.length > 0) {
			values.evidence.forEach((file) => {
				formData.append("files", file.originFileObj);
			});
		}

		try {
			const url = api + `/task/add/files/${id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const { data } = await axios.post(url, formData, config);
			if (data.success) {
				openNotification("success", "Success", "Task Updated");

				setTimeout(() => {
					setLoadingButton(false);
					history.push("/task/dashboard");
				}, 2000);
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to add images task",
			);
			console.error(err.message);
			return null;
		}
	};

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	};

	const onChangeEvidence = ({ file, fileList }) => {
		if (file.url && file.status === "removed") {
			setEvidenceRemoved((prev) => [...prev, file.url]);
		}
		if (fileList.length === 0) {
			setEvidenceAdded(false);
		} else {
			setEvidenceAdded(true);
		}
	};

	const onFinish = (values) => {
		setLoadingButton(true);
		updateTask(values);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={8}>
						<Form.Item label="Task Number" name="number">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={24}>
						<Form.Item
							label="Title"
							name="title"
							rules={[
								{
									required: true,
									message: "Title is required",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24}>
						<Form.Item
							label="Description"
							name="description"
							rules={[
								{
									required: true,
									message: "Description is required",
								},
							]}
						>
							<Input.TextArea size="large" />
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Type"
							name="type"
							rules={[
								{
									required: true,
									message: "Types are required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select types"
								mode="multiple"
								options={optionsType}
								optionFilterProp="children"
								filterOption={filterOption}
								showSearch
								allowClear
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Status"
							name="status"
							rules={[
								{
									required: true,
									message: "Status is required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select status"
								options={statusOptions}
								optionFilterProp="children"
								filterOption={filterOption}
								showSearch
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Company"
							name="company"
							rules={[
								{
									required: true,
									message: "Company is required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select company"
								options={optionsCompany}
								optionFilterProp="children"
								filterOption={filterOption}
								showSearch
								allowClear
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={12}>
						<Form.Item
							label="Authorized By"
							name="authorizedBy"
							rules={[
								{
									required: true,
									message: "Authorized By is required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select authorized by"
								options={userList}
								optionFilterProp="children"
								filterOption={filterOption}
								showSearch
								loading={userLoading}
								disabled={
									!(
										localStorage.getItem("email") === "eliud@gmail.com" ||
										localStorage.getItem("email") === "pc@57concrete.com" ||
										localStorage.getItem("email") === "jc@57concrete.com" ||
										localStorage.getItem("email") === "gg@57xgroup.com" ||
										localStorage.getItem("email") === "ec@57concrete.com"
									)
								}
							/>
						</Form.Item>
					</Col>
					<Col span={24} xs={12}>
						<Form.Item label="Bill ID" name="billId">
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={24} xs={6}>
						<Form.Item label="Paid" name="paid" valuePropName="checked">
							<Checkbox>Is Paid?</Checkbox>
						</Form.Item>
					</Col>
					<Col span={24} xs={6}>
						<Form.Item label="Approved" name="approved" valuePropName="checked">
							<Checkbox disabled={disabledApproved}>Is Approved?</Checkbox>
						</Form.Item>
					</Col>
					<Col span={24} xs={12}>
						<Form.Item
							label="Evidence (Max Count: 10)"
							name="evidence"
							valuePropName="fileList"
							getValueFromEvent={normFile}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={10}
								multiple={true}
								accept=".pdf, .csv, .xls, .png, .jpg, .jpeg"
								onChange={onChangeEvidence}
								defaultFileList={defaultFileList}
							>
								<Button icon={<UploadOutlined />} size="large">
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Title level={3}>History</Title>
				<CustomTable
					loading={loading}
					columns={columns}
					data={historyStatus}
					isScroll={false}
				/>

				<Row gutter={16}>
					<Col span={24} sm={12} md={4}>
						<Button
							type="primary"
							htmlType="submit"
							loading={loadingButton}
							size="large"
							style={{
								width: "100%",
							}}
						>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Layout
			title="Edit Task"
			description="Update task attributes"
			type="medium"
		>
			{contextHolder}
			{loading ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default EditTask;
